export default "__VITE_PUBLIC_ASSET__da350722__"